import { toast } from "react-toastify";

export const AircallNofity = ({ type = 'success', Msg }: { type?: 'success' | 'error' | 'info' | 'warning', Msg: string }) => {
    toast(Msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        type,
    });
};